<template>
  <div class="banner" v-if="noActiveSchoolYears">
    <div class="banner__content">
      <p>{{ $t('vue2.common.no_active_school_years') }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Banner',
  computed: {
    noActiveSchoolYears () {
      return this.$store.state.noActiveSchoolYears
    }
  }
}
</script>

<style scoped>
.banner {
  background-color: #ff6b6b;
  color: white;
  padding: 15px 20px;
  text-align: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.banner__content {
  max-width: 1200px;
  margin: 0 auto;
}

.banner__content p {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
}
</style>


// WEBPACK FOOTER //
// Banner.vue?5ab2f0e2